import * as actions from "./actionTypes";

const initialData = {
  loaderPeriodoEvaluacion: false,
  periodoEvaluacion: null,
  periodoEvaluacionFalla: null,
  saveLoaderPeriodoEvaluacion: false,
  periodoEvaluacionFormError:null
};

export default function PeriodoEvaluacionReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADER_PERIODO_EVALUACION:
      return { ...state, loaderPeriodoEvaluacion: action.payload };

    case actions.GET_PERIODO_EVALUACION:
      return { ...state, periodoEvaluacion: action.payload };

    case actions.PERIODO_EVALUACION_FALLA:
      return { ...state, periodoEvaluacionFalla: action.payload };

    case actions.SAVE_LOADER_PERIODO_EVALUACION:
      return { ...state, saveLoaderPeriodoEvaluacion: action.payload };

    case actions.FORM_PERIODO_EVALUACION_FAIL:
      return { ...state, periodoEvaluacionFormError: action.payload };
      
    default:
      return state;
  }
}
